export const formats = [
  'YYYY年M月D日',
  'YYYY-MM-DD HH:mm:ss',
  'HH:mm',
  'YYYY-MM-DD',
];

export const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
